import React from 'react';
import { InputText } from 'components/inputText/inputText';
import { formatText } from 'core/i18n';
import validator from 'validator';

const isRequired = value => value && value.length;
const isValidDay = value => validator.matches(value, /^[0-9]$|^[0-2]\d$|^3[0-1]$/) && value <= 31;
export const BirthDay = ({
    userProfile,
    userProfileForm,
    formActions,
    handleCursor,
    validateGroups,
    onFocus,
    onBlur,
}) => {
    return (
        <div className="col-xs-3 input-month-day first-col">
            <InputText
                profileModel="userProfile.birthDay"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                name="birthDay"
                placeholder={formatText('field-birthDay')}
                disabled={userProfile?.birthDayDisabled}
                maxLength={2}
                onlyDigits
                onChange={event => handleCursor(event)}
                validations={{
                    required: isRequired,
                    valid: isValidDay,
                }}
                isValidated={() => validateGroups('birthDay', true)}
                isNotValidated={() => validateGroups('birthDay', false)}
                messagesError={{ required: '' }}
                userProfileForm={userProfileForm}
                userProfile={userProfile}
                formActions={formActions}
                onFocus={onFocus}
                onBlur={onBlur}
            />
        </div>
    );
};
